import { useCallback, useLayoutEffect, useRef } from 'react';

const useStableCallback = <Args extends unknown[], Return>(callback: (...args: Args) => Return) => {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...args: Args) => callbackRef.current(...args), []);
};

export default useStableCallback;
